module.exports = __webpack_public_path__ + "img/share_posters.75d1ca68.png";